// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"394":"a6691019","453":"72f42e35","819":"8941343b"}[chunkId] + ".chunk.js";
};